import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=26d3078a&"
import script from "./ProjectItem.vue?vue&type=script&lang=ts&"
export * from "./ProjectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports